import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker as AntdDatePicker } from 'antd';
import PropTypes from 'prop-types';
import './DateTimePicker.css';


const { RangePicker } = AntdDatePicker;

export default class DateTimePicker extends Component {

  static propTypes = {
    exportData: PropTypes.func,
    value: PropTypes.array
  };

  state = {};

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }


  onChange(dates) {
    let dateStart = dates[0];
    let dateEnd = dates[1];
    const daysDiff = dateEnd.diff(dateStart, 'days');
    if (daysDiff && daysDiff < 365 * 15) { //condition to exclude 'Today' & 'All Time'
      dateStart = dateStart.startOf('day');
      dateEnd = dateEnd.startOf('day');
    }
    this.props.exportData(dateStart, dateEnd);
  }

  render() {
    return (
      <RangePicker
        value={ this.props.value }
        ranges={ {
          'Today': [moment().startOf('day'), moment()],
          'Yesterday': [moment().startOf('day').subtract(1, 'day'), moment().startOf('day')],
          'This Week': [moment().startOf('week'), moment().endOf('week')],
          'Last 7 Days': [moment().startOf('day').subtract(7, 'day'), moment().startOf('day')],
          'Last 10 Days': [moment().startOf('day').subtract(10, 'day'), moment().startOf('day')],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last 30 Days': [moment().startOf('day').subtract(30, 'day'), moment().startOf('day')],
          'This Year': [moment().startOf('year'), moment().endOf('year')],
          'All Time': [moment('2000-01-01'), moment()]
        } }
        format="YYYY/MM/DD"
        onChange={ (a, b) => this.onChange(a, b) }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/datetimepicker/DateTimePicker.jsx